import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators, AbstractControl} from "@angular/forms";
import {Title} from "@angular/platform-browser";
import {TldManagerUserService} from "../../user/services/tld-manager-user.service";
import {emailValidator} from "common-domain";


function trimmedRequiredValidator(control: AbstractControl) {
  const value = control.value;
  if (typeof value === 'string' && value.trim().length === 0) {
    return { required: true };
  }
  return null;
}

@Component({
    selector: 'app-recover-user-name-init',
    templateUrl: './recover-user-name-init.component.html',
    styleUrls: ['./recover-user-name-init.component.scss'],
    standalone: false
})
export class RecoverUserNameInitComponent implements OnInit {

  emailSent: boolean;
  recoverUserNameForm: FormGroup;
  errorMessages: any;

  constructor(private titleService: Title, private formBuilder: FormBuilder, private userService: TldManagerUserService) {
  }

  ngOnInit() {
    this.createForm();
    this.titleService.setTitle('Recover Username');
  }

  onSubmit() {
    if (this.recoverUserNameForm.invalid) {
      this.recoverUserNameForm.markAsTouched();
      return;
    }
    const rawValue = this.recoverUserNameForm.getRawValue();
    const email = (rawValue.email || '').trim();
    const password = rawValue.password;

    this.userService.recoveryUserName(email, password).subscribe(data => {
    }, error => {
      this.errorMessages = error;
    }, () => {
      this.emailSent = true;
    });
  }

  private createForm() {
    this.recoverUserNameForm = this.formBuilder.group({
      email: new FormControl('', [Validators.required, trimmedRequiredValidator, emailValidator]),
      password: new FormControl('', [Validators.required]),

    });
  }

}
